/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {CreateAquabyteConnection} from '../bioplanModels';
// @ts-ignore
import type {CreateBioplanExternalAPIConnection} from '../bioplanModels';
// @ts-ignore
import type {CreateDataIntegrationConnection} from '../bioplanModels';
// @ts-ignore
import type {CreateFishtalkAPIConnection} from '../bioplanModels';
// @ts-ignore
import type {CreateFishtalkEmailConnection} from '../bioplanModels';
// @ts-ignore
import type {CreateOptoscaleConnection} from '../bioplanModels';
// @ts-ignore
import type {DataIntegrationConnection} from '../bioplanModels';
// @ts-ignore
import type {DataIntegrationConnectionCheck} from '../bioplanModels';
// @ts-ignore
import type {DataIntegrationConnectionSynchronize} from '../bioplanModels';
/**
 * DataIntegrationApi - axios parameter creator
 * @export
 */
export const DataIntegrationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create data integration connection with Aquabyte
     * @param {CreateAquabyteConnection} createAquabyteConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsAquabytePost: async (
      createAquabyteConnection: CreateAquabyteConnection,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createAquabyteConnection' is not null or undefined
      assertParamExists('dataIntegrationConnectionsAquabytePost', 'createAquabyteConnection', createAquabyteConnection);
      const localVarPath = `/dataIntegration/connections/aquabyte`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        createAquabyteConnection,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create data integration connection with external system
     * @param {CreateBioplanExternalAPIConnection} createBioplanExternalAPIConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsBioplanPost: async (
      createBioplanExternalAPIConnection: CreateBioplanExternalAPIConnection,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createBioplanExternalAPIConnection' is not null or undefined
      assertParamExists(
        'dataIntegrationConnectionsBioplanPost',
        'createBioplanExternalAPIConnection',
        createBioplanExternalAPIConnection,
      );
      const localVarPath = `/dataIntegration/connections/bioplan`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        createBioplanExternalAPIConnection,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Test data integration connection
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsConnectionIdCheckGet: async (
      connectionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('dataIntegrationConnectionsConnectionIdCheckGet', 'connectionId', connectionId);
      const localVarPath = `/dataIntegration/connections/{connectionId}/check`.replace(
        `{${'connectionId'}}`,
        encodeURIComponent(String(connectionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsConnectionIdDelete: async (
      connectionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('dataIntegrationConnectionsConnectionIdDelete', 'connectionId', connectionId);
      const localVarPath = `/dataIntegration/connections/{connectionId}`.replace(
        `{${'connectionId'}}`,
        encodeURIComponent(String(connectionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get single data integration systems for tenant
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsConnectionIdGet: async (
      connectionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('dataIntegrationConnectionsConnectionIdGet', 'connectionId', connectionId);
      const localVarPath = `/dataIntegration/connections/{connectionId}`.replace(
        `{${'connectionId'}}`,
        encodeURIComponent(String(connectionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Synchronize data integration connection
     * @param {string} connectionId
     * @param {string} [fromDate]
     * @param {string} [toDate]
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsConnectionIdSynchronizePut: async (
      connectionId: string,
      fromDate?: string,
      toDate?: string,
      force?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'connectionId' is not null or undefined
      assertParamExists('dataIntegrationConnectionsConnectionIdSynchronizePut', 'connectionId', connectionId);
      const localVarPath = `/dataIntegration/connections/{connectionId}/synchronize`.replace(
        `{${'connectionId'}}`,
        encodeURIComponent(String(connectionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (fromDate !== undefined) {
        localVarQueryParameter['fromDate'] =
          (fromDate as any) instanceof Date ? (fromDate as any).toISOString().substring(0, 10) : fromDate;
      }

      if (toDate !== undefined) {
        localVarQueryParameter['toDate'] =
          (toDate as any) instanceof Date ? (toDate as any).toISOString().substring(0, 10) : toDate;
      }

      if (force !== undefined) {
        localVarQueryParameter['force'] = force;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create data integration connection with Fishtalk API
     * @param {CreateFishtalkAPIConnection} createFishtalkAPIConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsFishtalkAPIPost: async (
      createFishtalkAPIConnection: CreateFishtalkAPIConnection,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createFishtalkAPIConnection' is not null or undefined
      assertParamExists(
        'dataIntegrationConnectionsFishtalkAPIPost',
        'createFishtalkAPIConnection',
        createFishtalkAPIConnection,
      );
      const localVarPath = `/dataIntegration/connections/fishtalkAPI`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        createFishtalkAPIConnection,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create data integration connection with Fishtalk via scheduled email reports
     * @param {CreateFishtalkEmailConnection} createFishtalkEmailConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsFishtalkEmailPost: async (
      createFishtalkEmailConnection: CreateFishtalkEmailConnection,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createFishtalkEmailConnection' is not null or undefined
      assertParamExists(
        'dataIntegrationConnectionsFishtalkEmailPost',
        'createFishtalkEmailConnection',
        createFishtalkEmailConnection,
      );
      const localVarPath = `/dataIntegration/connections/fishtalkEmail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        createFishtalkEmailConnection,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get data integration systems for tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/dataIntegration/connections`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create data integration connection with Optoscale
     * @param {CreateOptoscaleConnection} createOptoscaleConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsOptoscalePost: async (
      createOptoscaleConnection: CreateOptoscaleConnection,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createOptoscaleConnection' is not null or undefined
      assertParamExists(
        'dataIntegrationConnectionsOptoscalePost',
        'createOptoscaleConnection',
        createOptoscaleConnection,
      );
      const localVarPath = `/dataIntegration/connections/optoscale`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        createOptoscaleConnection,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create data integration connection with external system
     * @param {CreateDataIntegrationConnection} createDataIntegrationConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsPost: async (
      createDataIntegrationConnection: CreateDataIntegrationConnection,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createDataIntegrationConnection' is not null or undefined
      assertParamExists(
        'dataIntegrationConnectionsPost',
        'createDataIntegrationConnection',
        createDataIntegrationConnection,
      );
      const localVarPath = `/dataIntegration/connections`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        createDataIntegrationConnection,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Import data from Fishtalk email
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationImportFishtalkEmailPut: async (
      file: File,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists('dataIntegrationImportFishtalkEmailPut', 'file', file);
      const localVarPath = `/dataIntegration/importFishtalkEmail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DataIntegrationApi - functional programming interface
 * @export
 */
export const DataIntegrationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DataIntegrationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create data integration connection with Aquabyte
     * @param {CreateAquabyteConnection} createAquabyteConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationConnectionsAquabytePost(
      createAquabyteConnection: CreateAquabyteConnection,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataIntegrationConnection>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationConnectionsAquabytePost(
        createAquabyteConnection,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationConnectionsAquabytePost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create data integration connection with external system
     * @param {CreateBioplanExternalAPIConnection} createBioplanExternalAPIConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationConnectionsBioplanPost(
      createBioplanExternalAPIConnection: CreateBioplanExternalAPIConnection,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataIntegrationConnection>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationConnectionsBioplanPost(
        createBioplanExternalAPIConnection,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationConnectionsBioplanPost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Test data integration connection
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationConnectionsConnectionIdCheckGet(
      connectionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataIntegrationConnectionCheck>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationConnectionsConnectionIdCheckGet(
        connectionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationConnectionsConnectionIdCheckGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationConnectionsConnectionIdDelete(
      connectionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationConnectionsConnectionIdDelete(
        connectionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationConnectionsConnectionIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get single data integration systems for tenant
     * @param {string} connectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationConnectionsConnectionIdGet(
      connectionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataIntegrationConnection>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationConnectionsConnectionIdGet(
        connectionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationConnectionsConnectionIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Synchronize data integration connection
     * @param {string} connectionId
     * @param {string} [fromDate]
     * @param {string} [toDate]
     * @param {boolean} [force]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationConnectionsConnectionIdSynchronizePut(
      connectionId: string,
      fromDate?: string,
      toDate?: string,
      force?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataIntegrationConnectionSynchronize>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationConnectionsConnectionIdSynchronizePut(
        connectionId,
        fromDate,
        toDate,
        force,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationConnectionsConnectionIdSynchronizePut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create data integration connection with Fishtalk API
     * @param {CreateFishtalkAPIConnection} createFishtalkAPIConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationConnectionsFishtalkAPIPost(
      createFishtalkAPIConnection: CreateFishtalkAPIConnection,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataIntegrationConnection>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationConnectionsFishtalkAPIPost(
        createFishtalkAPIConnection,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationConnectionsFishtalkAPIPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create data integration connection with Fishtalk via scheduled email reports
     * @param {CreateFishtalkEmailConnection} createFishtalkEmailConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationConnectionsFishtalkEmailPost(
      createFishtalkEmailConnection: CreateFishtalkEmailConnection,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataIntegrationConnection>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationConnectionsFishtalkEmailPost(
        createFishtalkEmailConnection,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationConnectionsFishtalkEmailPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get data integration systems for tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationConnectionsGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataIntegrationConnection>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationConnectionsGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationConnectionsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create data integration connection with Optoscale
     * @param {CreateOptoscaleConnection} createOptoscaleConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationConnectionsOptoscalePost(
      createOptoscaleConnection: CreateOptoscaleConnection,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataIntegrationConnection>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationConnectionsOptoscalePost(
        createOptoscaleConnection,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationConnectionsOptoscalePost']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create data integration connection with external system
     * @param {CreateDataIntegrationConnection} createDataIntegrationConnection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationConnectionsPost(
      createDataIntegrationConnection: CreateDataIntegrationConnection,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataIntegrationConnection>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationConnectionsPost(
        createDataIntegrationConnection,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationConnectionsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Import data from Fishtalk email
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dataIntegrationImportFishtalkEmailPut(
      file: File,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Error>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dataIntegrationImportFishtalkEmailPut(file, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['DataIntegrationApi.dataIntegrationImportFishtalkEmailPut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DataIntegrationApi - factory interface
 * @export
 */
export const DataIntegrationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DataIntegrationApiFp(configuration);
  return {
    /**
     *
     * @summary Create data integration connection with Aquabyte
     * @param {DataIntegrationApiDataIntegrationConnectionsAquabytePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsAquabytePost(
      requestParameters: DataIntegrationApiDataIntegrationConnectionsAquabytePostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DataIntegrationConnection> {
      return localVarFp
        .dataIntegrationConnectionsAquabytePost(requestParameters.createAquabyteConnection, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create data integration connection with external system
     * @param {DataIntegrationApiDataIntegrationConnectionsBioplanPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsBioplanPost(
      requestParameters: DataIntegrationApiDataIntegrationConnectionsBioplanPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DataIntegrationConnection> {
      return localVarFp
        .dataIntegrationConnectionsBioplanPost(requestParameters.createBioplanExternalAPIConnection, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Test data integration connection
     * @param {DataIntegrationApiDataIntegrationConnectionsConnectionIdCheckGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsConnectionIdCheckGet(
      requestParameters: DataIntegrationApiDataIntegrationConnectionsConnectionIdCheckGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DataIntegrationConnectionCheck> {
      return localVarFp
        .dataIntegrationConnectionsConnectionIdCheckGet(requestParameters.connectionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DataIntegrationApiDataIntegrationConnectionsConnectionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsConnectionIdDelete(
      requestParameters: DataIntegrationApiDataIntegrationConnectionsConnectionIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .dataIntegrationConnectionsConnectionIdDelete(requestParameters.connectionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get single data integration systems for tenant
     * @param {DataIntegrationApiDataIntegrationConnectionsConnectionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsConnectionIdGet(
      requestParameters: DataIntegrationApiDataIntegrationConnectionsConnectionIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DataIntegrationConnection> {
      return localVarFp
        .dataIntegrationConnectionsConnectionIdGet(requestParameters.connectionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Synchronize data integration connection
     * @param {DataIntegrationApiDataIntegrationConnectionsConnectionIdSynchronizePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsConnectionIdSynchronizePut(
      requestParameters: DataIntegrationApiDataIntegrationConnectionsConnectionIdSynchronizePutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DataIntegrationConnectionSynchronize> {
      return localVarFp
        .dataIntegrationConnectionsConnectionIdSynchronizePut(
          requestParameters.connectionId,
          requestParameters.fromDate,
          requestParameters.toDate,
          requestParameters.force,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create data integration connection with Fishtalk API
     * @param {DataIntegrationApiDataIntegrationConnectionsFishtalkAPIPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsFishtalkAPIPost(
      requestParameters: DataIntegrationApiDataIntegrationConnectionsFishtalkAPIPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DataIntegrationConnection> {
      return localVarFp
        .dataIntegrationConnectionsFishtalkAPIPost(requestParameters.createFishtalkAPIConnection, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create data integration connection with Fishtalk via scheduled email reports
     * @param {DataIntegrationApiDataIntegrationConnectionsFishtalkEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsFishtalkEmailPost(
      requestParameters: DataIntegrationApiDataIntegrationConnectionsFishtalkEmailPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DataIntegrationConnection> {
      return localVarFp
        .dataIntegrationConnectionsFishtalkEmailPost(requestParameters.createFishtalkEmailConnection, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get data integration systems for tenant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataIntegrationConnection>> {
      return localVarFp.dataIntegrationConnectionsGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create data integration connection with Optoscale
     * @param {DataIntegrationApiDataIntegrationConnectionsOptoscalePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsOptoscalePost(
      requestParameters: DataIntegrationApiDataIntegrationConnectionsOptoscalePostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DataIntegrationConnection> {
      return localVarFp
        .dataIntegrationConnectionsOptoscalePost(requestParameters.createOptoscaleConnection, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create data integration connection with external system
     * @param {DataIntegrationApiDataIntegrationConnectionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationConnectionsPost(
      requestParameters: DataIntegrationApiDataIntegrationConnectionsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DataIntegrationConnection> {
      return localVarFp
        .dataIntegrationConnectionsPost(requestParameters.createDataIntegrationConnection, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Import data from Fishtalk email
     * @param {DataIntegrationApiDataIntegrationImportFishtalkEmailPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dataIntegrationImportFishtalkEmailPut(
      requestParameters: DataIntegrationApiDataIntegrationImportFishtalkEmailPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Error> {
      return localVarFp
        .dataIntegrationImportFishtalkEmailPut(requestParameters.file, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for dataIntegrationConnectionsAquabytePost operation in DataIntegrationApi.
 * @export
 * @interface DataIntegrationApiDataIntegrationConnectionsAquabytePostRequest
 */
export interface DataIntegrationApiDataIntegrationConnectionsAquabytePostRequest {
  /**
   *
   * @type {CreateAquabyteConnection}
   * @memberof DataIntegrationApiDataIntegrationConnectionsAquabytePost
   */
  readonly createAquabyteConnection: CreateAquabyteConnection;
}

/**
 * Request parameters for dataIntegrationConnectionsBioplanPost operation in DataIntegrationApi.
 * @export
 * @interface DataIntegrationApiDataIntegrationConnectionsBioplanPostRequest
 */
export interface DataIntegrationApiDataIntegrationConnectionsBioplanPostRequest {
  /**
   *
   * @type {CreateBioplanExternalAPIConnection}
   * @memberof DataIntegrationApiDataIntegrationConnectionsBioplanPost
   */
  readonly createBioplanExternalAPIConnection: CreateBioplanExternalAPIConnection;
}

/**
 * Request parameters for dataIntegrationConnectionsConnectionIdCheckGet operation in DataIntegrationApi.
 * @export
 * @interface DataIntegrationApiDataIntegrationConnectionsConnectionIdCheckGetRequest
 */
export interface DataIntegrationApiDataIntegrationConnectionsConnectionIdCheckGetRequest {
  /**
   *
   * @type {string}
   * @memberof DataIntegrationApiDataIntegrationConnectionsConnectionIdCheckGet
   */
  readonly connectionId: string;
}

/**
 * Request parameters for dataIntegrationConnectionsConnectionIdDelete operation in DataIntegrationApi.
 * @export
 * @interface DataIntegrationApiDataIntegrationConnectionsConnectionIdDeleteRequest
 */
export interface DataIntegrationApiDataIntegrationConnectionsConnectionIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof DataIntegrationApiDataIntegrationConnectionsConnectionIdDelete
   */
  readonly connectionId: string;
}

/**
 * Request parameters for dataIntegrationConnectionsConnectionIdGet operation in DataIntegrationApi.
 * @export
 * @interface DataIntegrationApiDataIntegrationConnectionsConnectionIdGetRequest
 */
export interface DataIntegrationApiDataIntegrationConnectionsConnectionIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof DataIntegrationApiDataIntegrationConnectionsConnectionIdGet
   */
  readonly connectionId: string;
}

/**
 * Request parameters for dataIntegrationConnectionsConnectionIdSynchronizePut operation in DataIntegrationApi.
 * @export
 * @interface DataIntegrationApiDataIntegrationConnectionsConnectionIdSynchronizePutRequest
 */
export interface DataIntegrationApiDataIntegrationConnectionsConnectionIdSynchronizePutRequest {
  /**
   *
   * @type {string}
   * @memberof DataIntegrationApiDataIntegrationConnectionsConnectionIdSynchronizePut
   */
  readonly connectionId: string;

  /**
   *
   * @type {string}
   * @memberof DataIntegrationApiDataIntegrationConnectionsConnectionIdSynchronizePut
   */
  readonly fromDate?: string;

  /**
   *
   * @type {string}
   * @memberof DataIntegrationApiDataIntegrationConnectionsConnectionIdSynchronizePut
   */
  readonly toDate?: string;

  /**
   *
   * @type {boolean}
   * @memberof DataIntegrationApiDataIntegrationConnectionsConnectionIdSynchronizePut
   */
  readonly force?: boolean;
}

/**
 * Request parameters for dataIntegrationConnectionsFishtalkAPIPost operation in DataIntegrationApi.
 * @export
 * @interface DataIntegrationApiDataIntegrationConnectionsFishtalkAPIPostRequest
 */
export interface DataIntegrationApiDataIntegrationConnectionsFishtalkAPIPostRequest {
  /**
   *
   * @type {CreateFishtalkAPIConnection}
   * @memberof DataIntegrationApiDataIntegrationConnectionsFishtalkAPIPost
   */
  readonly createFishtalkAPIConnection: CreateFishtalkAPIConnection;
}

/**
 * Request parameters for dataIntegrationConnectionsFishtalkEmailPost operation in DataIntegrationApi.
 * @export
 * @interface DataIntegrationApiDataIntegrationConnectionsFishtalkEmailPostRequest
 */
export interface DataIntegrationApiDataIntegrationConnectionsFishtalkEmailPostRequest {
  /**
   *
   * @type {CreateFishtalkEmailConnection}
   * @memberof DataIntegrationApiDataIntegrationConnectionsFishtalkEmailPost
   */
  readonly createFishtalkEmailConnection: CreateFishtalkEmailConnection;
}

/**
 * Request parameters for dataIntegrationConnectionsOptoscalePost operation in DataIntegrationApi.
 * @export
 * @interface DataIntegrationApiDataIntegrationConnectionsOptoscalePostRequest
 */
export interface DataIntegrationApiDataIntegrationConnectionsOptoscalePostRequest {
  /**
   *
   * @type {CreateOptoscaleConnection}
   * @memberof DataIntegrationApiDataIntegrationConnectionsOptoscalePost
   */
  readonly createOptoscaleConnection: CreateOptoscaleConnection;
}

/**
 * Request parameters for dataIntegrationConnectionsPost operation in DataIntegrationApi.
 * @export
 * @interface DataIntegrationApiDataIntegrationConnectionsPostRequest
 */
export interface DataIntegrationApiDataIntegrationConnectionsPostRequest {
  /**
   *
   * @type {CreateDataIntegrationConnection}
   * @memberof DataIntegrationApiDataIntegrationConnectionsPost
   */
  readonly createDataIntegrationConnection: CreateDataIntegrationConnection;
}

/**
 * Request parameters for dataIntegrationImportFishtalkEmailPut operation in DataIntegrationApi.
 * @export
 * @interface DataIntegrationApiDataIntegrationImportFishtalkEmailPutRequest
 */
export interface DataIntegrationApiDataIntegrationImportFishtalkEmailPutRequest {
  /**
   *
   * @type {File}
   * @memberof DataIntegrationApiDataIntegrationImportFishtalkEmailPut
   */
  readonly file: File;
}

/**
 * DataIntegrationApi - object-oriented interface
 * @export
 * @class DataIntegrationApi
 * @extends {BaseAPI}
 */
export class DataIntegrationApi extends BaseAPI {
  /**
   *
   * @summary Create data integration connection with Aquabyte
   * @param {DataIntegrationApiDataIntegrationConnectionsAquabytePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationConnectionsAquabytePost(
    requestParameters: DataIntegrationApiDataIntegrationConnectionsAquabytePostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationConnectionsAquabytePost(requestParameters.createAquabyteConnection, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create data integration connection with external system
   * @param {DataIntegrationApiDataIntegrationConnectionsBioplanPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationConnectionsBioplanPost(
    requestParameters: DataIntegrationApiDataIntegrationConnectionsBioplanPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationConnectionsBioplanPost(requestParameters.createBioplanExternalAPIConnection, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Test data integration connection
   * @param {DataIntegrationApiDataIntegrationConnectionsConnectionIdCheckGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationConnectionsConnectionIdCheckGet(
    requestParameters: DataIntegrationApiDataIntegrationConnectionsConnectionIdCheckGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationConnectionsConnectionIdCheckGet(requestParameters.connectionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DataIntegrationApiDataIntegrationConnectionsConnectionIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationConnectionsConnectionIdDelete(
    requestParameters: DataIntegrationApiDataIntegrationConnectionsConnectionIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationConnectionsConnectionIdDelete(requestParameters.connectionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get single data integration systems for tenant
   * @param {DataIntegrationApiDataIntegrationConnectionsConnectionIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationConnectionsConnectionIdGet(
    requestParameters: DataIntegrationApiDataIntegrationConnectionsConnectionIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationConnectionsConnectionIdGet(requestParameters.connectionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Synchronize data integration connection
   * @param {DataIntegrationApiDataIntegrationConnectionsConnectionIdSynchronizePutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationConnectionsConnectionIdSynchronizePut(
    requestParameters: DataIntegrationApiDataIntegrationConnectionsConnectionIdSynchronizePutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationConnectionsConnectionIdSynchronizePut(
        requestParameters.connectionId,
        requestParameters.fromDate,
        requestParameters.toDate,
        requestParameters.force,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create data integration connection with Fishtalk API
   * @param {DataIntegrationApiDataIntegrationConnectionsFishtalkAPIPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationConnectionsFishtalkAPIPost(
    requestParameters: DataIntegrationApiDataIntegrationConnectionsFishtalkAPIPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationConnectionsFishtalkAPIPost(requestParameters.createFishtalkAPIConnection, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create data integration connection with Fishtalk via scheduled email reports
   * @param {DataIntegrationApiDataIntegrationConnectionsFishtalkEmailPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationConnectionsFishtalkEmailPost(
    requestParameters: DataIntegrationApiDataIntegrationConnectionsFishtalkEmailPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationConnectionsFishtalkEmailPost(requestParameters.createFishtalkEmailConnection, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get data integration systems for tenant
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationConnectionsGet(options?: RawAxiosRequestConfig) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationConnectionsGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create data integration connection with Optoscale
   * @param {DataIntegrationApiDataIntegrationConnectionsOptoscalePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationConnectionsOptoscalePost(
    requestParameters: DataIntegrationApiDataIntegrationConnectionsOptoscalePostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationConnectionsOptoscalePost(requestParameters.createOptoscaleConnection, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create data integration connection with external system
   * @param {DataIntegrationApiDataIntegrationConnectionsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationConnectionsPost(
    requestParameters: DataIntegrationApiDataIntegrationConnectionsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationConnectionsPost(requestParameters.createDataIntegrationConnection, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Import data from Fishtalk email
   * @param {DataIntegrationApiDataIntegrationImportFishtalkEmailPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DataIntegrationApi
   */
  public dataIntegrationImportFishtalkEmailPut(
    requestParameters: DataIntegrationApiDataIntegrationImportFishtalkEmailPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DataIntegrationApiFp(this.configuration)
      .dataIntegrationImportFishtalkEmailPut(requestParameters.file, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
